import { AfterViewInit, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import { TextInputComponent } from '@navstation-portal/shared/ui/components';
import { TIMEZONE_OPTIONS } from '@navstation-portal/shared/util/time';
import {
  AbstractStoreConnectedSectionComponent,
  offshoreOperationalEvents,
  OffshoreOperationalFormStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { LatLongTemplateComponent } from '../../../../shared/lat-long-template/lat-long-template.component';

@Component({
  selector: 're-port-and-position',
  templateUrl: './port-and-position.component.html',
  styleUrl: './port-and-position.component.css',
  imports: [FormsModule, LatLongTemplateComponent, TextInputComponent],
})
export class PortAndPositionComponent
  extends AbstractStoreConnectedSectionComponent
  implements AfterViewInit
{
  timezoneOptions = TIMEZONE_OPTIONS;
  tabId = 'operational';
  sectionId = 'portAndPosition';
  events = injectDispatch(offshoreOperationalEvents);
  operationalStore = inject(OffshoreOperationalFormStore);
}
